/*
 * FAQ Accordion item
 */
'use strict';

jQuery($ => {

    $('.gecko-faq-item__container[data-status="active"]').each((i, el) => {
        const item = $(el);
        const content = item.find('.gecko-faq-item__content');
        content.stop().slideDown();
    });

	$(".gecko-faq-item__container").on('click', (e) => {
        e.preventDefault();
        const item = $(e.currentTarget);
        const content = item.find('.gecko-faq-item__content');

        if (item.attr('data-status') === 'active') {
            item.removeAttr('data-status');
            content.stop().slideUp();
        } else {
            item.attr('data-status', 'active');
            content.stop().slideDown();
        }
	});

});
